import { Link } from '@mui/material'
import { memo } from 'react'

import { NAVIGATION_BLANK_PARAMS } from '../../../util/navigation.helpers'

const ExternalLink = ({ label, to, ...restProps }) => {
  return (
    <Link
      key={label}
      href={to}
      color='inherit'
      variant='body2'
      {...NAVIGATION_BLANK_PARAMS}
      {...restProps}
    >
      {label}
    </Link>
  )
}

export default memo(ExternalLink)
